import type { DataLayer } from "./types";

/**
 * Removes deprecated data layer vars from local storage data layer
 * @param data DataLayer
 * @returns DataLayer
 */
export const removeDeprecatedDataLayerVars = (
  data: Record<string, any>
): DataLayer => {
  const deprecatedDataLayerVars = [
    "spending_limit",
    "personasID",
    "CurrentMembershipStartDate",
    "LatestSubscriptionId",
    "MemberCancellationDate",
    "MembershipSKUUpdatedDate",
    "TotallifetimeAmountSaved",
    "LifetimeValueMembership",
    "LifetimeValueOrders",
    "Login"
  ];
  const updatedData = { ...data };
  deprecatedDataLayerVars.forEach((varName) => {
    if (varName in updatedData) {
      delete updatedData[varName];
    }
  });
  return updatedData as DataLayer;
};
